let apiRoot = '/api/v1'
let API_URL = '/api/v1/gabd2' // gdb2
// let api1 = '/api/v1/gabd2'
let ape = '/api/v1/ape' // 祖源模块

let smallProductApi = '/api/small'

export default {
  // str
  contact: '010-64863376',
  /* Get 请求 */
  childwes_zy_demo: apiRoot + '/childwes_zy_demo', //中源协和定制项目demo报告登录接口接口
  custom_cover: apiRoot + '/custom_cover', //获取中源协和定制封面接口
  getlogo: apiRoot + '/getlogo', // 获取logo地址和针对的名称
  captcha: apiRoot + '/captcha', // 登录---验证码
  // captcha1: api1 + '/validate_code',
  user: apiRoot + '/home/user', // 首页---用户数据
  quantity: apiRoot + '/home/quantity', // 首页---各解读项数量
  suggestions: apiRoot + '/home/suggestions', // 首页---获取生活建议、体检筛查、家人建议
  diseases_quantity: apiRoot + '/disease/quantity', // 疾病风险---疾病模块解读项数量接口
  high_diseases: apiRoot + '/disease/high_diseases', // 疾病风险---成人版
  children_high_diseases: apiRoot + '/disease/children_high_diseases', // 疾病风险---儿童版儿童时期
  adult_high_diseases: apiRoot + '/disease/adult_high_diseases', // 疾病风险---儿童版其他时期
  diseases_details: apiRoot + '/disease/details', // 疾病风险---获取疾病详情(disease易感性疾病,tumour遗传性肿瘤)
  disease_systems: apiRoot + '/disease/systems', // 疾病风险---按系统浏览
  disease_items: apiRoot + '/disease/items', // 疾病风险---按照系统分类获取疾病列表
  inherit_quantity: apiRoot + '/inherit/quantity', // 单基因病---疾病模块解读项数量接口
  inherit_carry_inherits: apiRoot + '/inherit/carry_inherits', // 单基因病---携带的单基因病列表
  inherit_items: apiRoot + '/inherit/items', // 单基因病---全部单基因病列表接口（按项目浏览）
  inherit_details: apiRoot + '/inherit/details', // 单基因病---详情页
  drug_quantity: apiRoot + '/drug/quantity', // 精准用药---疾病模块解读项数量接口
  drug_attention_drugs: apiRoot + '/drug/attention_drugs', // 精准用药---需关注解读项列表接口
  drug_details: apiRoot + '/drug/details', // 精准用药---药物详情接口
  drug_systems: apiRoot + '/drug/systems', // 精准用药---药物系统分类接口（按系统浏览）
  drug_items: apiRoot + '/drug/items', // 精准用药---按照系统分类获取药物列表
  talent_quantity: apiRoot + '/talent/quantity', // 特质基因---疾病模块解读项数量接口
  talent_attention_talents: apiRoot + '/talent/attention_talents', // 特质基因---需关注解读项列表接口
  talent_details: apiRoot + '/talent/details', // 特质基因---特质基因详情
  talent_systems: apiRoot + '/talent/systems', // 特质基因---系统分类接口
  talent_items: apiRoot + '/talent/items', // 特质基因---按照系统分类获取特质基因列表
  rare_quantity: apiRoot + '/rare/quantity', // 可治罕见病---疾病模块解读项数量接口
  rare_carry_rares: apiRoot + '/rare/carry_rares', // 可治罕见病---携带的可治罕见病列表接口
  rare_items: apiRoot + '/rare/items', // 可治罕见病---全部可治罕见病列表接口
  rare_details: apiRoot + '/rare/details', // 可治罕见病---可知罕见病详情
  search: apiRoot + '/search', // 搜索接口
  current_disease_list: apiRoot + '/current/disease_list', // 现状测试---现状评估疾病列表
  current_question_list: apiRoot + '/current/question_list', // 现状测试---获取问题列表信息
  current_add_result: apiRoot + '/current/add_result', // 现状测试---添加结论
  current_result_list: apiRoot + '/current/result_list', // 现状测试---现状评估结论
  assessment_getintotype: apiRoot + '/risk/getintotype', // 风险评估---获取风险评估入口
  assessment_sendmail: apiRoot + '/sendmail', // 风险评估---申请评测
  assessment_add_personinfo: apiRoot + '/risk/add_personinfo', // 风险评估---添加个人信息
  assessment_get_continue: apiRoot + '/risk/get_continue', // 风险评估---获取中途退出保留的数据
  assessment_risk_list: apiRoot + '/risk/risk_list', // 风险评估---疾病列表和疾病详情数据
  assessment_again_review: apiRoot + '/risk/again_review', // 风险评估---重新测试
  /* Post 请求 */
  login: apiRoot + '/login', // 登录
  // login1: api1 + '/user_login', // 登录 gdb2
  pager: apiRoot + '/pager', // 翻页功能接口
  /* localstorage key */
  access_token: 'token', // 登录令牌
  username: 'username', // 登录账号
  child: 'child', // 用于判断是否为儿童，1 为儿童，0 为成人
  sample_type: 'sample_type', // 用于判断右边栏模块的显示
  status: 'status', // 用于判断数据库，1 为gdb3， 0为gdb2
  lsHighLvDisSort: 'lsHighLvDisSort',
  uid: 'uid', // uid
  // gdb2
  // sampleInfo: api1 + '/sampleInfo',
  report: API_URL + '/report',
  search1: API_URL + '/search',
  highLevelDisease: API_URL + '/disease?risk=1&rate=1',
  diseaseSystemInfo: API_URL + '/disease_system_info',
  tumourDetails: API_URL + '/tumour_details',
  diseaseDetails: API_URL + '/disease_details',
  drugIndex: API_URL + '/drug_index',
  drugSystemInfo: API_URL + '/drug_system_info',
  drugDetails: API_URL + '/drug_details',
  inherit: API_URL + '/Inherit',
  inheritAppendix: API_URL + '/Inherit_appendix',
  inheritDetails: API_URL + '/Inherit_details',
  talentIndex: API_URL + '/talent_index',
  talentSystemInfo: API_URL + '/talent_system_info',
  talentDetails: API_URL + '/talent_details',
  // 祖源模块
  overview: ape + '/overview', // 祖源数据概览
  items: ape + '/items', // 祖源成分
  paternal_haploid: ape + '/paternal_haploid', // 父系单倍体
  maternal_haploid: ape + '/maternal_haploid', // 母系单倍体
  neanderthal: ape + '/neanderthal', // 尼安德特人数据
  // 忘记密码
  checkFeature: apiRoot + '/checkFeature', // 检查是否有重置密码功能接口
  getSMSVerifyCode: apiRoot + '/getSMSVerifyCode', // 获取短信验证码
  resetPassword: apiRoot + '/resetPassword', // 重置密码接口
  updatePassword: apiRoot + '/updatePassword', // 修改密码

  // 多样本
  select: apiRoot + '/select', // 样本选择页面

  // 神经酰胺
  point_status: apiRoot + '/ceramide/point_status', // 获取神经酰胺状态值接口
  add_info: apiRoot + '/ceramide/add_info', // 添加神经酰胺用户信息接口
  result: apiRoot + '/ceramide/result', // 获取神经酰胺检测结果接口
  cer_status: apiRoot + '/ceramide/cer_status', // 获取CER产品状态接口

  // 综合结论
  conclusion: apiRoot + '/cardiovascular/conclusion', // 获取多组学综合结论接口
  car_status: apiRoot + '/cardiovascular/status', // 获取多组学综合结论状态接口

  // 20231204  小产品在线报告接口 （肿瘤七项为例）
  // sampleList: smallProductApi + 'sample-list', // 账号下的样本列表
  // sampleInfo: smallProductApi + 'sample-info', // 样本的状态信息
  diseaseReport: smallProductApi + '/disease-report', // 样本疾病报告
  diseaseItem: smallProductApi + '/disease-item', // 疾病单项报告
  diseaseInfo: smallProductApi + '/disease-info', // 疾病信息
  diseaseGene: smallProductApi + '/disease-gene', // 疾病解读项基因位点
  referenceItem: smallProductApi + '/reference-item', // 账号下样本的参考文献
}



// WEBPACK FOOTER //
// ./src/libs/api.js